import { curry } from "lodash/fp"
import { SingleFeelingModel } from "services/openapi"

const feelingIdEquals = (feelingId: number, feeling: SingleFeelingModel) => {
  return feeling.feelingId === feelingId
}

export default curry(feelingIdEquals)
